
// 🍂function jsonFromResponse: {}
// Returns the JSON data corresponding to a `fetch` API request, or throws an
// error. Useful when chained to a `fetch` Promise.
export function jsonFromResponse (response) {
    if (response.status >= 400) {
        throw new Error(response.status + ' ' + response.statusText);
    }
    return response.json();
}

// 🍂function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
// be appended at the end. If `uppercase` is `true`, the parameter names will
// be uppercased (e.g. `'?A=foo&B=bar'`)
export function getParamString (obj, existingUrl, uppercase) {
    var params = [];
    for (var i in obj) {
        params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
    }
    return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
}

// Parse a url parameter and get it's value back
export function parseUrlParam(name, string){
    var href = string;
    var results = new RegExp('[\\?&]' + name + '=([^\\?&#]*)').exec(href);
    if (!results || !results[1]){
        return null;
    }else{
        return decodeURIComponent(results && results[1]);
    }
}


// WEBPACK FOOTER //
// src/Shared/UrlParser/utils.js